<div class="absolute bottom-0 right-0 flex flex-col gap-y-2 z-10" [hidden]="!showZoomButtonElements()" [class]="showButtons ? 'pointer-events-auto' : 'hidden pointer-events-none'">
    
    <!-- ZOOM IN -->
    <app-button
        #zoomInButton
        [type]="type"
        [color]="color"
        [disabled]="maxZoom"
        class="contents"
    >
        <!-- ICON -->
        <svg ngProjectAs="icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="size-3.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
        </svg>
      
    </app-button>

    <!-- ZOOM OUT -->
    <app-button
        #zoomOutButton
        [type]="type"
        [color]="color"
        [disabled]="minZoom"
        class="contents"
    >

        <svg ngProjectAs="icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" class="size-3.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14" />
        </svg>
      

    </app-button>

</div>